import {getElementFromSessionStorage, setElementToSessionStorage} from 'app/helpers/webStorageUtility';
import Video from 'app/components/tv/models/video';

export const DEFAULT_AD_CREDITS = 80;
const STORAGE_KEY = 'adCredits';

export const updateAdCredits = (video: Video, playedTimeRanges: TimeRanges): void => {
  const adCredits = getAdCredits();
  const playedTime = video.getPlayedTime(playedTimeRanges);
  const newAdCredits = adCredits - playedTime;
  setElementToSessionStorage(STORAGE_KEY, String(newAdCredits));
};

const getAdCredits = (): number => {
  return Number(getElementFromSessionStorage(STORAGE_KEY));
};

export const setAdCredits = (credits: number = DEFAULT_AD_CREDITS): void => {
  setElementToSessionStorage(STORAGE_KEY, String(credits));
};

export const checkPlayAd = (): boolean => {
  const adCredits = getAdCredits();
  return !(adCredits && adCredits <= DEFAULT_AD_CREDITS && adCredits > 0);
};
